import React from "react";

import { Button } from "@material-ui/core";

const SrButton = ({ children, ...props }) => (
  <Button {...props} disableElevation>
    {children}
  </Button>
);

export default SrButton;
